<template>
    <div class="d-flex">
        <div v-bind:class="statusClass">
            <span
                v-if="!noIcon"
                class="me-1">
                <pc-bs-icon v-bind:name="iconName" />
            </span>
            <span v-bind:class="textClass">
                {{ text }}
            </span>
        </div>
    </div>
</template>
<script>
    import {
        ESIGNATURE_STATUS_SEVERITY,
        getESignatureStatusTextClassBySeverity,
        getESignatureStatusTextBubbleClassBySeverity
    } from "ESignatures/eSignatureConstants";

    export default {
        props: {
            text: { type: String, required: true },
            statusSeverity: { type: Number, required: false, default: ESIGNATURE_STATUS_SEVERITY.Info },
            noTextColor: { type: Boolean, required: false, default: false },
            noIcon: { type: Boolean, required: false, default: false },
            fillIcon: { type: Boolean, required: false, default: false },
            bubbleText: { type: Boolean, required: false, default: false },
            bold: { type: Boolean, required: false, default: false },
            italic: { type: Boolean, required: false, default: false }
        },
        computed: {
            statusClass() {
                const classObj = {};
                if (!this.noTextColor) {
                    const textColorClassName = getESignatureStatusTextClassBySeverity(this.statusSeverity);
                    classObj[textColorClassName] = true;
                }
                if (this.bubbleText) {
                    const textBubbleClassName = getESignatureStatusTextBubbleClassBySeverity(this.statusSeverity);
                    classObj[textBubbleClassName] = true;
                }
                return classObj;
            },
            textClass() {
                return {
                    "fw-bold": this.bold,
                    "fst-italic": this.italic
                };
            },
            textBubbleClass() {
                if (!this.bubbleText) {
                    return null;
                }
                return getESignatureStatusTextBubbleClassBySeverity(this.statusSeverity);
            },
            iconName() {
                switch (this.statusSeverity) {
                    case ESIGNATURE_STATUS_SEVERITY.Info:
                    case ESIGNATURE_STATUS_SEVERITY.Success:
                        return this.fillIcon ? "check-circle-fill" : "check-circle";
                    case ESIGNATURE_STATUS_SEVERITY.Warning:
                    case ESIGNATURE_STATUS_SEVERITY.Error:
                        return this.fillIcon ? "exclamation-circle-fill" : "exclamation-circle";
                    default:
                        throw `Unexpected status severity value: ${this.statusSeverity}`;
                }
            }
        }
    };
</script>
